export const AI = 0 // CAF
export const REVIEW = 1 // tutor feedback
export const RECORD = 2
export const NOTE = 3

export enum REVIEW_TABS {
  AI,
  FEEDBACK,
  RECORD,
  NOTE,
}
